import 'error-polyfill';
import axios from 'axios';
import axiosAdapter from 'axios/lib/adapters/xhr';

import ApiClient from './api-client';

const { defaults } = axios;

const clientsMap = {};

const regex = /\.\/(.*)\/index.js/;
const files = require.context('.', true, /\.\/(.*)\/index.js/);

files.keys().forEach((key) => {
  const match = key.match(regex);
  // console.log('registered client:', match[1], files(key).default);
  clientsMap[match[1]] = files(key).default;
});

class ClientFactory {
  constructor(config) {
    defaults.adapter = config.adapter || axiosAdapter;
    defaults.baseURL = config.baseURL || '';
    defaults.proxy = config.proxy || null;
    defaults.headers.common = {
      ...defaults.headers.common,
      'Content-Type': 'application/json',
      'x-accesskey': '',
      'x-jwt-token': '',
      'Cache-control': 'no-cache',
      Pragma: 'no-cache',
      Expires: -1,
    };

    const apiClient = new ApiClient(axios.create(), config.eventBus);

    this.setCredentials = (accessKey, jwtToken) => {
      apiClient.accessKey = accessKey;
      apiClient.jwtToken = jwtToken;
    };

    this.instanceClient = (name, options = {}) => new clientsMap[name]({
      apiClient,
      ...options,
    });

    this.instanced = {};
  }

  getClient(name, opts) {
    if (!this.instanced[name]) {
      this.instanced[name] = this.instanceClient(name, opts);
    }
    return this.instanced[name];
  }
}

export default {
  install: (Vue, opts) => {
    const client = new ClientFactory(opts);

    // eslint-disable-next-line no-param-reassign
    Vue.api = client;
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$api = client;
  },
};
